module.exports = __webpack_public_path__ + "static/media/wizualizacja-150.85f76c66.png";